import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Pagination from '@material-ui/lab/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, TablePagination, withStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DebounceInput } from 'react-debounce-input';
import loader from '../../images/Spin-1s-107px.gif';
import * as moment from 'moment';
import windowSize from "react-window-size";


import {
    getSettlemetEnrichmentQuestion,
    getAllSettlement,
    getEnrollSettlementForUser,
    getAlLFeatureSettlement,
    getAllCategory,
    getSettlementListByAffiliateType,
    getAffiliateUser,
} from '../../Actions/actions';

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: '#fff',
        color: '#525659',

    },
    body: {
        fontSize: 14,

    },
}))(TableCell);


class SettlementDashboardContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            settlementDataAffiliateData: {},
            userid: localStorage.getItem('userId'),
            affiliateType: '',
            GetAffiliateUserData: '',
            rowsPerPage: 10,
            pageNumber: 1,
            searchKeyword: '',
            isLoader: false,
            sortBy: ''
        };

    }


    async componentDidMount() {
        const { userid, searchKeyword } = this.state
        this.setState({
            isLoader: true
        })
        await this.props.getAllCategory({
            searchKeyword: searchKeyword,
        });
        await this.props.getAffiliateUser(userid);
    }


    fetchData = (data) => {
        const { rowsPerPage, affiliateType, pageNumber, searchKeyword, sortBy, userid } = this.state
        this.setState({
            isLoader: true,
            pageNumber: data.searching || data.categoryFiltering ? data.pageNumber : pageNumber
        })
        this.props.getSettlementListByAffiliateType({
            pageNumber: data.searching || data.categoryFiltering ? 1 : pageNumber,
            pageSize: rowsPerPage,
            searchKeyword: searchKeyword,
            affiliateType: affiliateType,
            userId: userid,
            sortBy: sortBy
        });
    }


    componentDidUpdate() {
        const {
            GetAffiliateUser,
            settlementDataAffiliate
        } = this.props.data;
        const {
            GetAffiliateUserData,
            settlementDataAffiliateData
        } = this.state;
        if (GetAffiliateUserData !== GetAffiliateUser) {
            this.setState({
                affiliateType: GetAffiliateUser && GetAffiliateUser.affiliateType,
                GetAffiliateUserData: GetAffiliateUser,
            }, () => {
                // if (GetAffiliateUser && GetAffiliateUser.affiliateType && GetAffiliateUser.affiliateType !== "") {
                    this.fetchData({searching: false, categoryFiltering: false   })
                // }
            });
        }

        if (settlementDataAffiliate !== settlementDataAffiliateData) {
            this.setState({
                settlementDataAffiliateData: settlementDataAffiliate,
                isLoader: false
            })
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({
            pageNumber: parseInt(newPage, 10)
        }, () => {
            this.fetchData({searching: false, categoryFiltering: false   })
        })
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10)
        }, () => {
            this.fetchData({searching: false, categoryFiltering: false   })
        })
    };

    render() {
        let totPageCount
        const {
            rowsPerPage,
            pageNumber,
            searchKeyword,
            isLoader,
            sortBy
        } = this.state;
        const { data: { settlementDataAffiliate, AllCategory } } = this.props

        return (
            <div className="">
                {isLoader === true ? (
                    <div className="loader">
                        <img src={loader} alt="" />
                    </div>
                ) : ''}

                <div className="tab-container-inner">
                    <div className="breadcrumbs mob-hide tab-hide">
                        <Link to="/affiliate">
                            Settlements
                        </Link>
                        <span>

                        </span>
                    </div>
                    <div className="card-table-outer">
                    <div className="table-filter">
                        <h3 className="table-filter-tittle"><em className="mob-hide">Settlements </em>  {settlementDataAffiliate && settlementDataAffiliate.result && (<span>({settlementDataAffiliate.result.totalCount})</span>)} </h3>
                        <div className="filter-form">
                            <div className="input-search-outer">
                                <DebounceInput
                                    placeholder="Search"
                                    type="search"
                                    // className={className}
                                    debounceTimeout={500}
                                    onChange={(evet) => {
                                        this.setState({
                                            searchKeyword: evet.target.value
                                        }, () => {
                                            this.fetchData({searching: true,pageNumber:1, categoryFiltering: false})
                                        })
                                    }}
                                    forceNotifyByEnter={false}
                                    value={searchKeyword}
                                />

                                <SearchIcon className="p-serch-icon " />
                            </div>
                            <div className="tab-right settlement-dd-tab">
                                <select className='p-ro-select' name="opts" placeholder="Select an option" value={sortBy} onChange={(event) => {
                                    this.setState({
                                        sortBy: event.target.value
                                    }, () => {
                                        this.fetchData({searching: false,pageNumber:1, categoryFiltering: true   })
                                    })
                                }} >
                                    <option value=''>All Settlements</option>
                                    {

                                        AllCategory && AllCategory.map((categoryList) => (
                                            <option key={categoryList.categoryId} value={categoryList.categoryId}>{categoryList.name}</option>
                                        ))
                                    }

                                    {/* <option value='1'>First item</option>
                                    
                                    <option value='3'>Third item</option>
                                    <option value='4'>Last item</option> */}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="p-table-outer">
                        {settlementDataAffiliate && settlementDataAffiliate.code === 200 ? (
                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <CustomTableCell>Name</CustomTableCell>
                                        <CustomTableCell >Category</CustomTableCell>
                                        <CustomTableCell >Filing Deadline</CustomTableCell>
                                        <CustomTableCell >Total Enrollments</CustomTableCell>
                                        <CustomTableCell >Resources</CustomTableCell>
                                    </TableRow>
                                </TableHead>


                                <TableBody className="p-table-body">{
                                    settlementDataAffiliate.result ?
                                        settlementDataAffiliate.result.records.map((item) => (
                                            <TableRow key={item.id} >
                                                <CustomTableCell >{this.props.windowWidth < 600 ? (
                                                    <Link to={`/settlementAffiliate/enrollment-list/${item.id}`}
                                                    >
                                                        {item.shortName}

                                                    </Link>

                                                ) : item.shortName}</CustomTableCell>
                                                <CustomTableCell >
                                                    {item.categoryName}
                                                </CustomTableCell>
                                                <CustomTableCell >{item.settlementImportantDateDto !== undefined ? moment(item.settlementImportantDateDto.claimPeriodEnd !== undefined ? item.settlementImportantDateDto.claimPeriodEnd : '').format('MM/DD/YYYY') !== 'Invalid date' ? moment(item.settlementImportantDateDto.claimPeriodEnd !== undefined ? item.settlementImportantDateDto.claimPeriodEnd : '').format('MM/DD/YYYY') : 'TBA' : ''}</CustomTableCell>



                                                <CustomTableCell >
                                                    <Link
                                                        // to={`/SettlementAffiliate/`}
                                                        to={`/settlementAffiliate/enrollment-list/${item.id}`}
                                                    >
                                                        {item.enrolledUsers}</Link></CustomTableCell>

                                                <CustomTableCell ><Link
                                                    // to={`/SettlementAffiliate/`}
                                                    to={`/settlementAffiliate/${item.id}`}
                                                >View</Link></CustomTableCell>
                                            </TableRow>
                                        ))
                                        : (<TableRow className="record-notfound" >
                                            <CustomTableCell >Record Not found</CustomTableCell></TableRow>)
                                }</TableBody>




                            </Table>) : (
                                 <Table >
                                 <TableHead>
                                     <TableRow>
                                         <CustomTableCell>Name</CustomTableCell>
                                         <CustomTableCell >Category</CustomTableCell>
                                         <CustomTableCell >Filing Deadline</CustomTableCell>
                                         <CustomTableCell >Total Enrollments</CustomTableCell>
                                         <CustomTableCell >Resources</CustomTableCell>
                                     </TableRow>
                                 </TableHead>
                                 <TableBody>
                                 <TableRow className="record-notfound" >
                                            <CustomTableCell >Record Not found</CustomTableCell>
                                  </TableRow>
                                </TableBody>




                            </Table>
 
                            )}
                    </div>
                    {/* <div className={classes.root}> */}
                    {/* {console.log('settlementDataAffiliate.result.totalCount/settlementDataAffiliate.result.pageSize', settlementDataAffiliate.result && Math.ceil(settlementDataAffiliate.result.totalCount/settlementDataAffiliate.result.pageSize))} */}
                   {console.log('pageNumber((((((((((', this.state.pageNumber)}
                    <Pagination 
                        count={settlementDataAffiliate.result && settlementDataAffiliate.result.totalCount > settlementDataAffiliate.result.pageSize ? Math.ceil(settlementDataAffiliate.result.totalCount/settlementDataAffiliate.result.pageSize) : 1} variant="outlined" shape="rounded"
                        // count={settlementDataAffiliate.result && Math.round(settlementDataAffiliate.result.totalCount/settlementDataAffiliate.result.pageSize)} variant="outlined" shape="rounded"
                        onChange={this.handleChangePage}
                        page={pageNumber}
                        className="custom-pagination"
                    />
    {/* </div> */}
                    {/* <TablePagination
                        component="div"
                        className="pagination-table"
                        count={settlementDataAffiliate && settlementDataAffiliate.result && settlementDataAffiliate.result.totalCount ? settlementDataAffiliate.result.totalCount : 0}
                        rowsPerPage={rowsPerPage}
                        page={pageNumber}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    /> */}
                    </div>
                </div>
            </div>
        );
    }
}



const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getSettlemetEnrichmentQuestion,
            getAllSettlement,
            getEnrollSettlementForUser,
            getAlLFeatureSettlement,
            getAllCategory,
            getSettlementListByAffiliateType,
            getAffiliateUser,
        },
        dispatch,
    );

export default
    windowSize(
        connect(
            mapStateToProps,
            mapDispatchToProps,
        )(SettlementDashboardContainer));
